import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const imageCheck = async (data: object) => {
  return await POST({
    url: Api.imageCheck,
    data,
    showError: false
  })
}
